import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
  Container,
  Number,
  Title,
  Name,
  Icon,
  SelectedIcon,
  DeleteIcon,
  DetailsColumn,
  IconColumn,
} from './styled';
import * as cardTypeAssests from './assets';
import CheckIcon from './CheckIcon.svg';
import SelectIcon from './Select.svg';
import DeleteSVG from './Delete.svg';

function Card({
  edit: _edit,
  shrink: _shrink,
  class: cardClass = 'debit',
  name,
  last4,
  type,
  style,
  onClick,
  selected,
  onDelete,
  nickName,
}) {
  const mobileMediaQuery = useMediaQuery('(max-width:500px)');
  const shrink = typeof _shrink !== 'undefined';
  const edit = typeof _edit !== 'undefined';
  return (
    <Container
      data-cy="credit-card-item"
      shrink={shrink}
      color={
        cardTypeAssests && cardTypeAssests[type]
          ? cardTypeAssests[type].color
          : cardTypeAssests['bank'].color
      }
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : null,
        ...style,
      }}>
      <DetailsColumn>
        {!shrink ? (
          <Title>{cardClass.match(/debit/gi) ? 'debit' : 'credit'}</Title>
        ) : null}
        <Number shrink={shrink}>{nickName ? nickName : `**** **** **** ${last4}`}</Number>
        <Name shrink={shrink}>{name}</Name>
      </DetailsColumn>
      <IconColumn>
        <Icon
          src={
            cardTypeAssests && cardTypeAssests[type]
              ? cardTypeAssests[type].icon
              : cardTypeAssests['bank'].icon
          }
        />
      </IconColumn>
      {selected && (
        <SelectedIcon src={mobileMediaQuery ? CheckIcon : SelectIcon} />
      )}
      {edit && <DeleteIcon data-cy="delete-card" onClick={() => onDelete(last4)} src={DeleteSVG} />}
    </Container>
  );
}

export default Card;
